import React from "react";
import styled from "styled-components";

const validatePassword = (password) =>
	[
		// [/[a-z]/, "Una letra minúscula"],
		// [/[A-Z]/, "Una letra mayúscula"],
		// [/\d/, "Un dígito"],
		// [/\W/, "Un símbolo"],
		[/(.+){8,}/, "Un largo mayor a 7 caracteres"],
	]
		.map(([regex, message]) =>
			regex.test(password)
				? { message, isError: false }
				: { message, isError: true }
		)
		.filter((e) => e !== null);

export const PasswordLegend = ({ password, desktop }) => {
	const errors = validatePassword(password);

	return (
		<SList>
			<LHead>
				<b>Requisitos Mínimos:</b>
			</LHead>
			<List errors={errors} desktop={desktop} />
		</SList>
	);
};

const List = ({ errors, desktop }) => {
	return errors.map((e) => (
		<Item isError={e.isError} desktop={desktop}>
			{e.isError ? (
				<img
					style={{ verticalAlign: "middle" }}
					src="https://i.ibb.co/K58tc0w/checked-21.png"
				/>
			) : (
				<img
					style={{ verticalAlign: "middle" }}
					src="https://img.icons8.com/color/25/000000/checked-2.png"
				/>
			)}{" "}
			{e.message}
		</Item>
	));
};

const SList = styled.ul`
	padding: 0;
`;

const LHead = styled.li`
	list-style: none;
	margin-bottom: 10px;
`;

const Item = styled.li`
	color: ${({ isError, desktop }) =>
		isError
			? desktop
				? "#a2a2a2"
				: "white"
			: desktop
			? "#145ab4"
			: "#b7f4b7"};
	list-style: ${({ isError }) => (isError ? "none" : "none")};
`;
